<template>
    <div>
        <div
            v-if="paidOnly && !hasSubscription"
            class="group relative"
            @click.prevent.stop="openSubscriptionModal"
        >
            <div
                class="-right-1 -top-1 h-5 w-5 bg-white shadow-md absolute z-50 flex items-center justify-center rounded-full transition-all duration-150 group-hover:scale-110"
            >
                <svg
                    class=""
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.33319 13.3332H12.6665M1.33319 2.6665L3.33319 10.6665H12.6665L14.6665 2.6665L10.6665 7.33317L7.99986 2.6665L5.33319 7.33317L1.33319 2.6665Z"
                        stroke="url(#paint0_linear_1067_2699)"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1067_2699"
                            x1="1.00018"
                            y1="1.99976"
                            x2="10.1364"
                            y2="14.5624"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#FF8D47" />
                            <stop offset="0.329612" stop-color="#FF8947" />
                            <stop offset="0.534043" stop-color="#FF4247" />
                            <stop offset="0.68692" stop-color="#E92A5B" />
                            <stop offset="0.828171" stop-color="#DD1C67" />
                            <stop offset="1" stop-color="#CF0283" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div
                class="button-wrapper group text-sm font-semibold text-white shadow-sm rounded-[8px] whitespace-nowrap"
            >
                <button
                    class="button-cta h-10 pr-[14px] pl-[8px]"
                    @click.prevent.stop="openSubscriptionModal"
                >
                    <Plus
                        class="mr-[8px]"
                        :size="20"
                        :stroke-width="2.25"
                    ></Plus>
                    <slot></slot>
                </button>
            </div>
        </div>

        <div
            v-else
            class="button-wrapper group text-sm font-semibold text-white shadow-sm rounded-[8px] whitespace-nowrap"
        >
            <button class="button-cta h-10 pr-[14px] pl-[8px]">
                <Plus class="mr-[8px]" :size="20" :stroke-width="2.25"></Plus>
                <slot></slot>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Plus } from "lucide-vue-next";

import { useHasSubscription } from "@/composables/useHasSubscription";
import useProDialog from "@/ProModal/composables/useProDialog";

interface Props {
    paidOnly?: boolean;
    feature?: string;
}
const props = withDefaults(defineProps<Props>(), {
    paidOnly: false,
});

const { hasSubscription } = useHasSubscription();

const proDialog = useProDialog();

async function openSubscriptionModal() {
    await proDialog.show({
        feature: props.feature,
    });
}
</script>

<style scoped>
.button-wrapper {
    display: flex;
    flex-direction: row;
    background: #26272b;
    position: relative;
    z-index: 1;
    overflow: hidden;
}

.button-wrapper::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: opacity 150ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
    background: linear-gradient(
        143.16deg,
        #ff8d47 5.29%,
        #ff7447 18.74%,
        #ff4247 46.66%,
        #e92a5b 63.32%,
        #dd1c67 72.74%,
        #d31071 82.09%,
        #cf0283 96.39%
    );
    opacity: 0;
}

.button-cta {
    order: 2;
    align-self: center;
    border: 0;
    background-color: transparent;
    color: white;
    font-size: 14px;
    text-align: left;
    position: relative;
    z-index: 3;
    display: inline-flex;
    word-break: keep-all;
    align-items: center;
}

.button-cta:hover {
    box-shadow: inset 0px 4px 8px rgba(255, 255, 255, 0.41);
    text-shadow: 0px 2px 3px #e0104e;
}

.button-cta:hover svg {
    filter: drop-shadow(0px 2px 3px #e0104e);
}

.button-wrapper:hover::after {
    opacity: 1;
}
</style>
